import { format } from 'date-fns'
import { DAY, MINUTE } from '@/constant/time.ts'

export const formatBirthDate = (birthDate?: string | null): string => {
    if (!birthDate) return '-'
    const date = new Date(birthDate)
    if (isNaN(date.getTime())) return birthDate
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

export interface ILastSeenLabel {
    key: string
    values?: { n?: number; date?: string }
}

const startOfDay = (date: Date): Date =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate())

/**
 * 디바이스의 마지막 통신 시각을 사람이 읽기 쉬운 라벨로 변환한다.
 * 최근 건은 상대 시간으로, 일주일이 지난 건은 날짜로 표기한다.
 */
export const describeLastSeen = (
    statusUpdatedAt?: string | null,
    isOnline?: boolean
): ILastSeenLabel => {
    if (!statusUpdatedAt) return { key: 'device.lastSeen.never' }

    const date = new Date(statusUpdatedAt)
    if (isNaN(date.getTime())) return { key: 'device.lastSeen.never' }
    if (isOnline) return { key: 'device.lastSeen.live' }

    const now = new Date()
    const minutes = Math.floor((now.getTime() - date.getTime()) / MINUTE)
    if (minutes < 60) {
        return { key: 'device.lastSeen.minutes', values: { n: Math.max(minutes, 1) } }
    }

    const hours = Math.floor(minutes / 60)
    if (hours < 24) {
        return { key: 'device.lastSeen.hours', values: { n: hours } }
    }

    const days = Math.round((startOfDay(now).getTime() - startOfDay(date).getTime()) / DAY)
    if (days <= 1) return { key: 'device.lastSeen.yesterday' }
    if (days < 7) return { key: 'device.lastSeen.days', values: { n: days } }

    return { key: 'device.lastSeen.date', values: { date: format(date, 'yyyy-MM-dd') } }
}
